import React, {Component, createRef} from 'react';
import {gsap} from 'gsap';
import './Scene9.css';
import c11 from '../../Resources/logos/Logo-sega copy.png';
import c12 from '../../Resources/logos/Logo-rovio copy.png';
import c13 from '../../Resources/logos/Logo-ironsource copy.png';
import c21 from '../../Resources/logos/Logo-Jamcity.png';
import c22 from '../../Resources/logos/Logo-Kwalee.png';
import c23 from '../../Resources/logos/Logo-outfit copy.png';
import c31 from '../../Resources/logos/Logo-Atari.png';
import c32 from '../../Resources/logos/Google Marketing Platform copy.png';
import c33 from '../../Resources/logos/Logo-smar+ copy.png';
import c41 from '../../Resources/logos/Logo-ubisoft.png';
import c42 from '../../Resources/logos/Logo-Xandr copy.png';
import c43 from '../../Resources/logos/Logo-anzu copy.png';

import MaxButton from "../MaxButton";
import {FormattedMessage} from "react-intl";
import {ch, cw} from "../../Utilities/utils";

const showClients = false;
const clients = createRef();
const scene9 = createRef();

class Scene9 extends Component<> {
    constructor(props) {
        super(props);
        this.underlined1 = createRef();
        this.underlined2 = createRef();
        this.line1 = createRef();
        this.line2 = createRef();
        this.container = createRef();
    }

    componentDidMount() {
        let line1Top = ch(this.underlined1, this.container);
        let line2Top = ch(this.underlined2, this.container);

        if (!showClients) {
            clients.current.style.display = 'none';
        }
        gsap.timeline({
            scrollTrigger: {
                trigger: scene9.current,
                start: 'top top',
                end: '+=80%',
                scrub: true,
                pin: '#s9'
            }
        }).from(scene9.current, {
            duration: 0.01,
            zIndex: 0,
        }).from(".s9-text", {
            opacity: 0,
            x: "-20vw",
            stagger: .2,
            duration: 3,
            repeat: 1,
            repeatDelay: 5,
            yoyo: true,
        }, '1')
        .fromTo(this.line1.current, {
            opacity: 0.5,
            width: 0,
            top: line1Top,
        }, {
            width: cw(this.underlined1, this.container, 'left', 1.02),
            top: line1Top,
            opacity: 1,
            duration: 2.5,
            repeat: 1,
            repeatDelay: 7,
            yoyo: true,
        }, "0")
        .fromTo(this.line2.current, {
            opacity: 0.5,
            width: 0,
            top: line2Top,
        }, {
            width: cw(this.underlined2, this.container, 'left', 1.02),
            top: line2Top,
            opacity: 1,
            duration: 3,
            repeat: 1,
            repeatDelay: 6,
            yoyo: true,
        }, "1")
        .from (['#s8ocV', '#s8ocH', '#s8rcV', '#s8rcH'], {
            opacity: 0,
            duration: 1,
        }, '0')
        .from(".s9-clientes", {
            opacity: 0.4,
            y: "+=70vh",
            stagger: .3,
            duration: 6,
        }, "0")
        .to([".s9-clientes"], {
            opacity: 0,
            marginTop: "-=50vh",
            stagger: .3,
            duration: 6,
        }, "10");
    }

    render() {
        return (
            <section ref={scene9} className={"s9-container bg1"}>
                <div id={'s9'} className='content'>
                    <div className={'s9-images-container right'}>
                        <section ref={clients}>
                            <h2>
                                <div className={"s9-clientes s9-clientes-title"}>
                                    <FormattedMessage id={"home_clients_title"}/>
                                </div>
                            </h2>
                            <div className={"s9-clientes-container"}>
                                <img src={c11} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c12} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c13} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c21} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c22} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c23} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c31} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c32} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c33} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c41} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c42} className={"s9-clientes"} alt={'Clientes'}/>
                                <img src={c43} className={"s9-clientes"} alt={'Clientes'}/>
                            </div>
                            <div className={'s9-clientes right'}>
                                <MaxButton clickEvent={() => window.open("https://showcase.etermax.com", "_blank")}>
                                    home_case_studies_button
                                </MaxButton>
                            </div>
                        </section>
                    </div>
                    <div ref={this.line1} className={'underline orange left accessibility-line'}/>
                    <div ref={this.line2} className={'underline orange left accessibility-line'}/>
                    <h1 className={'s9-text-container clip-all'} ref={this.container}>
                        <span ref={this.underlined1} className={"s9-text"}>
                            <FormattedMessage id={"home_clients_txt"}/>
                        </span>
                        <span ref={this.underlined2} className={"s9-text"}>
                            <FormattedMessage id={"home_clients_txt_2"}/>
                        </span>
                        <span className={"s9-text"}><FormattedMessage id={"home_clients_txt_3"}/></span>
                        <span className={"s9-text"}><FormattedMessage id={"home_clients_txt_4"}/></span>
                        <span className={"s9-text"}><FormattedMessage id={"home_clients_txt_5"}/></span>
                    </h1>
                </div>
            </section>
        )
    }
}

export default Scene9;
